import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateWebhookConfigurationMutation = createMutationHook(
  WebhooksApiClient.updateWebhookConfiguration,
  {
    mutationKey: ['updateWebhookConfiguration'],
  },
)
